import { render, staticRenderFns } from "./file-delete.vue?vue&type=template&id=a3204cc4"
import script from "./file-delete.vue?vue&type=script&lang=js"
export * from "./file-delete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports